export interface NumberPickerConfig {
    maxValue?: number;
    minValue?: number;
    value?: number;
}
